module.exports = __webpack_public_path__ + "static/FreeBuds4i-227b579217212ad0ca4d8324f188d55a.png";